import { ReportAPI } from '@business/api/report';
import { ReportId, ReportModuleId, ReportModulesResponse, ReportPageQuery } from '@business/entities/report';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';

export class ReportBloc extends BaseBloc {
  private readonly reportRepo = new Repository<ReportModulesResponse>({
    getItemId: module => module.id,
  });

  readonly modules$ = this.reportRepo.items$;

  readonly selectModule = this.reportRepo.selectItem;

  onReset() {
    this.reportRepo.reset();
  }

  fetchReports = () => {
    return ReportAPI.fetchModules().pipe(this.reportRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_pro_templates_error') }));
  };

  fetchReport = (moduleId: ReportModuleId, reportId: ReportId, query: ReportPageQuery) => {
    return ReportAPI.fetchReport(moduleId, reportId, query);
  };
}
